
import { Dashboard } from '@/components/Dashboard';
import { useScrollToTop } from '@/hooks/useScrollToTop';

const DashboardPage = () => {
  // Add scroll to top behavior
  useScrollToTop();
  
  return <Dashboard />;
};

export default DashboardPage;
